import Row from 'components/Row'
import { View } from 'components/View'
import React from 'react'
import { useTheme } from 'modules/styles/index.js'

/**
 * @param children
 * @returns {Element}
 * @constructor
 */
export default function ProfileImages ({
  children
}) {
  const theme = useTheme()

  let zIndex = 3
  let width
  const size = theme.sizes.icons.NORMAL
  const childrenCount = children.length
  if (childrenCount === 1) {
    width = size * 1.7
  } else if (childrenCount === 2) {
    width = size * 2.5
  } else {
    width = size * 3.2
  }
  const borderWidth = 2

  return (
    <Row
      ac
      mr={0.25}
      w={`${width}px`}
      style={{
        marginLeft: -borderWidth,
        position: 'relative'
      }}
    >
      {
        children.map((image, index) => {
          zIndex -= 1
          return (
            <View
              key={index}
              bdr='big'
              style={{
                position: 'absolute',
                left: index * size * 0.7,
                zIndex,
                border: '1px solid white'
              }}
            >
              {image}
            </View>
          )
        })
      }
    </Row>
  )
}
